uniform float uPointIntensity;
varying float vWave;

void main() {

    // --- CIRCULAR POINT MASK ---
    vec2 uv = gl_PointCoord - 0.5;
    float d = length(uv);
    if (d > 0.5) discard;

    // --- COOL MARBLE BASE (UNCHANGED) ---
    vec3 colorLow  = vec3(0.015, 0.018, 0.022);
    vec3 colorHigh = vec3(0.72,  0.76,  0.82);

    // --- WAVE NORMALIZATION (compressed) ---
    float t = clamp(vWave * 0.75 + 0.55, 0.0, 1.0);
    t = smoothstep(0.15, 0.95, t);   // avoids early blowout

    vec3 color = mix(colorLow, colorHigh, t);

    // --- MICRO CONTRAST (tempered) ---
    float micro = 0.82 + vWave * 0.18;
    color *= micro;

    // --- ENERGY COMPRESSION (KEY FIX) ---
    // Prevents additive stacking from blowing highlights
    color = color / (color + vec3(1.25));

    // --- APPLY BRIGHTNESS LAST ---
    color *= uPointIntensity;

    // --- SOFT EDGE FALLoff (independent of brightness) ---
    float alpha = smoothstep(0.5, 0.22, d);
    alpha *= 0.6;

    gl_FragColor = vec4(color, alpha);
}
